export const collectionSchema = (collection, cms, url) => {
    let collectionProducts = [];

    if (collection) {
        collection.products.nodes.forEach((product, index) => {
            collectionProducts.push({
                '@type': 'ListItem',
                position: index + 1,
                url: `https://caktusvape.co.nz/products/${product.handle}`,
                name: `${product.vendor} ${product.title}`
            });
        });
    }
    if (cms) {
        let positionCounter = 0;
        cms.sections.forEach((section) => {
            section.modules.forEach(module => {
                if (module._type === "module.productCarousel") {
                    module.items.forEach(item => {
                        item.products.forEach((product) => {
                            product = product.linkedStore[0];
                            positionCounter++;
                            collectionProducts.push({
                                '@type': 'ListItem',
                                position: positionCounter,
                                url: `https://caktusvape.co.nz/products/${product.handle}`,
                                name: `${product.vendor} ${product.title}`
                            });
                        });
                    });
                }
            });
        });
    }    

    const schema = {
        '@context': 'http://schema.org',
        '@type': 'CollectionPage',
        name: cms?.title,
        url: url,
        description:cms?.seo?.description,
        mainEntity: {
            '@type': 'ItemList',
            itemListElement: collectionProducts
        }
    };

    return schema;
};
